import React from 'react';
import classNames from 'classnames';
import styles from './PopupPremiumAnswerUsed.module.scss';
import Popup, { Props as PopupProps } from '../Popup';
import PremiumBenefits, {
  TitleVersion,
} from '../PremiumBenefits/PremiumBenefits';
import { Phrases } from '../../../utilities/constants/phrases';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import Title from '../../TitleWithGradient/TitleWithGradient';
import Button from '../../Button/Button';
import { ButtonSize, ButtonAppearance } from '../../ButtonBase/types';
import { EditorPopupId } from '../../../utilities/constants/popup-type';

const POPUP_ID = EditorPopupId.PREMIUM_ANSWER_USED;

interface Props extends Pick<PopupProps, 'isOpen' | 'onClose'> {
  onSkipClick: () => void;
}

const PopupPremiumAnswerUsed: React.FC<Props> = ({ isOpen, onSkipClick }) => (
  <Popup
    isOpen={isOpen}
    id={POPUP_ID}
    size='lg'
    role='alertdialog'
    dialogClassName={classNames(
      styles.popupPremiumAnswerUsed,
      'd-flex flex-col flex-ai-c gap-xxxs'
    )}>
    <Title
      title={renderTextWithIndexedTags(
        Phrases.POPUP_PREMIUM_ANSWER_USED_TITLE,
        [<span key='span-0' />]
      )}
      className='text-xl fw-bold ta-center mt-xs'
    />
    <p className='text-sm ta-center mb-xs'>
      {Phrases.POPUP_PREMIUM_ANSWER_USED_SUBTITLE}
    </p>
    <PremiumBenefits
      titleVersion={TitleVersion.V2}
      bordered
      ctaLabel={Phrases.PREMIUM_BENEFITS_CTA_LABEL_2}
    />
    <Button
      onClick={onSkipClick}
      appearance={ButtonAppearance.TEXT}
      size={ButtonSize.SMALL}
      className={styles.button}>
      {Phrases.SKIP_FOR_NOW_BUTTON_LABEL}
    </Button>
  </Popup>
);

export default PopupPremiumAnswerUsed;
